import { render, staticRenderFns } from "./discipline-table.vue?vue&type=template&id=6e50538c&scoped=true&"
import script from "./discipline-table.ts?vue&type=script&lang=ts&"
export * from "./discipline-table.ts?vue&type=script&lang=ts&"
import style0 from "./discipline-table.scss?vue&type=style&index=0&id=6e50538c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e50538c",
  null
  
)

export default component.exports